import {
    IconButton,
    Button,
    TextField,
    Checkbox,
    Autocomplete,
    FormControlLabel,
    FormHelperText,
    FormControl,
    CircularProgress
} from '@mui/material';
import { ContactPage, HighlightOff } from '@mui/icons-material';
import useKycVerification from '../hooks/useKycVerification';
import KycInfoSidebar from './KycInfoSidebar';
import { H5, H6 } from '../../../../../themes/typography';

function KycVerification({ onClose = () => { } }) {
    const {
        idProofOptions,
        formik,
        loading
    } = useKycVerification({ onSuccess: onClose });
    return (
        <section id="add-tax-invoice-detail-section">
            <div className="tax-invoice-detail-wrapper">
                <div className="tax-invoice-header">
                    <div className="tax-invoice-detail-title">
                        <span className="invoice-info-icon">
                            <ContactPage color="secondary" sx={{ fontSize: '1.5rem' }} />
                        </span>
                        <H5 fontWeight={600}>Complete KYC by providing a valid ID proof</H5>
                    </div>
                    <div className="tax-invoice-close-icon">
                        <IconButton onClick={onClose}>
                            <HighlightOff color="secondary" sx={{ fontSize: '1.75rem' }} />
                        </IconButton>
                    </div>
                </div>

                <div className="tax-invoice-details-content">
                    <div className="tax-invoice-details-left-content">
                        <form
                            id="kyc-verification-form"
                            onSubmit={formik.handleSubmit}
                            className="tax-invoice-detail-form-container"
                        >
                            <div className="tax-invoice-input-container">
                                <div className="tax-invoice-detail-two-input">
                                    <div className="tax-invoice-info-input">
                                        <Autocomplete
                                            fullWidth
                                            id="idProof"
                                            name="idProof"
                                            options={idProofOptions}
                                            inputValue={formik.values.idProof?.name}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, newValue) =>
                                                formik.setFieldValue('idProof', newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select ID Proof"
                                                    error={
                                                        formik.touched.idProof &&
                                                        Boolean(formik.errors.idProof)
                                                    }
                                                    helperText={
                                                        formik.touched.idProof &&
                                                        formik.errors.idProof
                                                    }
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="tax-invoice-info-input">
                                        {formik.values.idProof?.name === 'Aadhar Card' && (
                                            <TextField
                                                fullWidth
                                                id="aadharCardNumber"
                                                name="aadharCardNumber"
                                                label="Aadhar Card Number"
                                                value={formik.values.aadharNumber}
                                                onChange={(e) => {
                                                    // Only allow digits
                                                    const value = e.target.value.replace(/\D/g, '');
                                                    formik.setFieldValue('aadharNumber', value);
                                                }}
                                                error={
                                                    formik.touched.aadharNumber &&
                                                    Boolean(formik.errors.aadharNumber)
                                                }
                                                helperText={
                                                    formik.touched.aadharNumber &&
                                                    formik.errors.aadharNumber
                                                }
                                                slotProps={{
                                                    htmlInput: {
                                                        maxLength: 12,
                                                        pattern: '[0-9]*',
                                                        inputMode: 'numeric'
                                                    }
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="kyc-tnc">
                                <H6 fontWeight={400}>
                                    🛡️ This information is encrypted and is completely secure
                                    with us
                                </H6>
                                <FormControl>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                sx={radioBtnStyle}
                                                color="secondary"
                                                size="small"
                                                name="isTermsAccepted"
                                                checked={formik.values.isTermsAccepted}
                                                onChange={(e) =>
                                                    formik.setFieldValue(
                                                        'isTermsAccepted',
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                        }
                                        label="By clicking here, I acknowledge that i have read, understood & accept the Terms of Service & the Privacy Policy."
                                        sx={{
                                            fontSize: '0.875rem',
                                            alignItems: 'center',
                                            gap: '0.5rem',
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem'
                                            }
                                        }}
                                    />
                                    <FormHelperText
                                        error={
                                            formik.touched.isTermsAccepted &&
                                            Boolean(formik.errors.isTermsAccepted)
                                        }
                                    >
                                        {formik.touched.isTermsAccepted &&
                                            formik.errors.isTermsAccepted}
                                    </FormHelperText>
                                </FormControl>
                            </div>
                        </form>
                        <div className="tax-invoice-detail-form-action-button">
                            <Button
                                variant="main"
                                disabled={!formik.values.isTermsAccepted || !formik.values.aadharNumber || loading}
                                onClick={formik.handleSubmit}
                            >
                                Submit {loading && (
                                    <CircularProgress
                                        size={20}
                                        sx={{
                                            marginLeft: '0.75rem',
                                            color: 'var(--primary-color)'
                                        }}
                                    />
                                )}
                            </Button>
                        </div>
                    </div>
                    <div className="tax-invoice-details-right-content">
                        <KycInfoSidebar />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default KycVerification;

const radioBtnStyle = {
    padding: '0'
};